import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChannelType } from 'simpo-component-library';
import { FooterSocialChannelModel } from 'simpo-component-library/lib/sections/footer-section/footer-section.modal';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
import { TemplateService } from 'src/app/services/template.service';

@Component({
  selector: 'app-add-social-channels',
  templateUrl: './add-social-channels.component.html',
  styleUrls: ['./add-social-channels.component.scss']
})
export class AddSocialChannelsComponent {
  constructor(private eventEmitterService: TemplateService){}


  @Input() socialLink : FooterSocialChannelModel = {
    type: ChannelType.FACEBOOK,
    url: '',
    link: ''
  };
  @Input() content: any;
  @Input() newItem?: boolean;
  ngOnInit(){
    // if(this.data){
    //   this.socialLink = this.data.socialLink;
    // }
  }

  channels: Array<type> = [
    {
      type: ChannelType.FACEBOOK
    },
    {
      type: ChannelType.INSTAGRAM
    },
    {
      type: ChannelType.LINKEDIN
    },
    {
      type: ChannelType.TELEGRAM
    },
    {
      type: ChannelType.THREADS
    },
    {
      type: ChannelType.TWITTER
    },
    {
      type: ChannelType.YOUTUBE
    }
  ]

  closeDialog(){

  }

  addNewChannel(){
    this.content.socialLinks.channels.push(this.socialLink);
    this.eventEmitterService.secondaryEditor.emit({data: {tab: 'STYLE'}})
  }
}

interface type {
  type: ChannelType;
}
